import React, {FunctionComponent, useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';
import {Alignment, Button, Navbar} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import DefaultLogo from '../../../../assets/logo/logo_light.svg';
import config from '../../../../config';
import {getHeaderClassName} from './utils';

import './Header.scss';

interface IDummyHeaderProps {
}

export const DummyHeader: FunctionComponent<IDummyHeaderProps> = () => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  const logoUrl = config.app.logo_url || DefaultLogo;
  const isCustomLogo = !!config.app.logo_url;

  const customerName = config.app.customer_name;

  useEffect(() => {
    if (isCustomLogo) {
      setLogoLoaded(true);
    }
  }, [logoUrl, isCustomLogo]);

  return (
    <Navbar className={getHeaderClassName()}>
      <Navbar.Group className='header__navbar-group' align={Alignment.LEFT}>
        <NavLink to="/app" className={`header__${isCustomLogo ? 'custom_logo' : 'logo'}`}>
          {isCustomLogo && logoLoaded ? (
            <img
              src={logoUrl}
              alt={customerName}
              className="header__custom_logo__image"
            />
          ) : (
            <img
              src={DefaultLogo}
              alt={customerName}
              className="header__logo__image"
            />
          )}
        </NavLink>
        <Button className="bp4-skeleton" minimal={true} text="Home" icon={IconNames.HOME}/>
        <Button className="bp4-skeleton" minimal={true} text="Explore" icon={IconNames.GEOLOCATION}/>
        <Button className="bp4-skeleton" minimal={true} text="Data & Integrations" icon={IconNames.DATA_CONNECTION}/>
        <Button className="bp4-skeleton" minimal={true} text="Execution Log" icon={IconNames.PULSE}/>
        <Button className="bp4-skeleton" minimal={true} text="Administration" icon={IconNames.COG}/>
      </Navbar.Group>
      <Navbar.Group className="header__navbar-group" align={Alignment.RIGHT}>
        <Button className="bp4-skeleton" minimal={true} icon={IconNames.SEARCH}/>
      </Navbar.Group>
    </Navbar>
  );
};
